import { useSelector } from 'react-redux';
import UIUpgradeBanner from 'ui-addon-upgrades/ums/UIUpgradeBanner';
// @ts-expect-error Not converted yet
import ErrorBoundary from 'customer-data-objects-ui-components/ErrorBoundary';
import { RequestStatus, VIDEO_CAPACITY_PACKS_UPGRADE_THRESHOLD } from 'FileManagerCore/Constants';
import { getEmbeddableVideoLimit, getDaysRemainingToDowngrade, getUsedEmbeddableVideoCount, getVideoUsageRequestStatus } from 'FileManagerCore/selectors/Limits';
import VideoDowngradeAlert from 'FileManagerCore/components/modals/VideoDowngradeAlert';
import { jsx as _jsx } from "react/jsx-runtime";
const VideoLimitBanner = () => {
  const quantityUsed = useSelector(getUsedEmbeddableVideoCount);
  const quantityAllowed = useSelector(getEmbeddableVideoLimit);
  const fetchStatus = useSelector(getVideoUsageRequestStatus);
  const daysRemainingToDowngrade = useSelector(getDaysRemainingToDowngrade);
  if (fetchStatus !== RequestStatus.SUCCEEDED) {
    return null;
  }
  if (quantityUsed > quantityAllowed && typeof daysRemainingToDowngrade === 'number') {
    return /*#__PURE__*/_jsx(VideoDowngradeAlert, {});
  }
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(UIUpgradeBanner, {
      upgradeKey: "video-capacity-packs-files-dash",
      value: quantityUsed,
      limit: quantityAllowed,
      displayThreshold: quantityAllowed - VIDEO_CAPACITY_PACKS_UPGRADE_THRESHOLD
    })
  });
};
export default VideoLimitBanner;